/**
 * Claims Module Constants
 */

export const CLAIM_CATEGORIES = [
  { value: 'travel', label: 'Travel' },
  { value: 'food', label: 'Food & Meals' },
  { value: 'accommodation', label: 'Accommodation' },
  { value: 'communication', label: 'Communication' },
  { value: 'medical', label: 'Medical' },
  { value: 'office_supplies', label: 'Office Supplies' },
  { value: 'training', label: 'Training' },
  { value: 'ltc', label: 'LTC (Leave Travel)' },
  { value: 'reimbursement', label: 'Reimbursement' },
  { value: 'other', label: 'Other' }
];

export const STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-700',
  pending: 'bg-yellow-100 text-yellow-700',
  submitted: 'bg-blue-100 text-blue-700',
  verified: 'bg-purple-100 text-purple-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  paid: 'bg-emerald-100 text-emerald-700'
};

export const CATEGORY_ICONS = {
  travel: 'Plane',
  medical: 'Stethoscope',
  ltc: 'Palmtree',
  reimbursement: 'Receipt',
  food: 'Receipt',
  accommodation: 'Receipt',
  communication: 'Receipt',
  office_supplies: 'Receipt',
  training: 'Receipt',
  other: 'Receipt'
};

export const TAB_CATEGORIES = {
  all: [],
  reimbursement: ['reimbursement', 'office_supplies', 'food', 'communication'],
  medical: ['medical'],
  travel: ['travel', 'accommodation'],
  ltc: ['ltc']
};

export const TAB_DESCRIPTIONS = {
  all: null,
  reimbursement: 'Office supplies, food, and communication expenses',
  medical: 'Hospital bills, pharmacy, and health check-up expenses',
  travel: 'Transportation and accommodation expenses for business travel',
  ltc: 'Leave Travel Concession claims for approved travel'
};
